import React from 'react'
import { SimpleApp } from 'components/app'
import TwoFA from 'components/twofa'
import { Input } from 'components/common'


class Maintenance extends React.Component {
	render() {
		return (
			<div id="actionbox">
				<div className='altert center section'>{hp.store.under_maintenance}</div>
			</div>
		)
	}
}

class Login extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			tfa: 0,
			loading: false,
			isNormalAuthEnabled: false
		}
		this.user = {}
		this.plusinfo_class = hp.store.users_info_page_login && hp.store.users_info_page_login.length < 100 ? 'center' : null
	}

	onBack = () => {
		this.setState({tfa: 0})
	}

	onAuthGov = () => {
		http.get('/sessions/getAuthGov.json', {},
			(response, success) => {
				if (success) {
					$('[name=SAMLRequest]').val(response.saml_request);
					$('[name=RelayState]').val(response.relay);
					$('form#authgov').submit();
				}
			}
		)
	}

	redirect = (url = null) => {
		const { _r } = hp.settings
		
		if (url) {
			const params = _r && _r[0] != '/' ? _r : ''
			window.location.href = `${url}${params}`
		}
		else {
			window.location.href = _r || '/personal'
		}
	}

	onSubmit = (e) => {
		e.preventDefault()

		const { urlParams } = hp.settings
		const credentials = btoa( JSON.stringify(this.user) )
		const data = {
			credentials: credentials
		}
		const { token } = hp.settings
		data[token.name] = token.value

		if (hp.store.under_maintenance && urlParams.get('unlock') == 'ht') {
			data.unlock = 'ht'
		}
		
		const url_params = new URLSearchParams(window.location.search);
		if(url_params.get('_r')) {
			data._r = url_params.get('_r');
		}
		this.setState({loading: true})
		window.messages.clear()
		http.post('/sessions/doLogin.json', data, (response, success) => {
			if (success) {
				// verificar se user tem 2FA ativo, ou é obrigado a definir 2FA
				if (response.tfa == 1) {
					this.setState({tfa: response.tfa})
				}
				// tfa == 2, indica que é obrigatório a definição de 2FA mas user ainda não o definiu
				else if (hp.settings.sec_2fa > 1) {
					this.setState({tfa: 2})
				}
				else {
					this.redirect(response.redirect || null)
				}
			}
			this.setState({loading: false})
		})
		return false
	}

	onSubmitCode = (e) => {
		const { tfa_code } = this.user

		e.preventDefault()
		if (!tfa_code || tfa_code.length != 6) {
			alert('O código de autenticação tem de ter 6 digitos')
			return
		}
		const data = {
			credentials: btoa( JSON.stringify(this.user) )
		}
		this.setState({loading: true})
		window.messages.clear()
		http.post('/sessions/auth2FACode.json', data, (response, success) => {
			if (success) {
				this.redirect(response.redirect || null)
			}
			this.setState({loading: false})
		})
		return false
	}

	onNewCodeSubmitted = (response) => {
		this.redirect(response.redirect || null)
	}

	onSsoAdSubmit = () => {
		this.setState({loading: true})
		window.messages.clear()
		http.post('/sessions/doLoginSsoAd.json', null, (response, success) => {
			if (success) {
				this.redirect(response.redirect || null)
			}
			this.setState({loading: false})
		})
		return false
	}

	onToggleNormAuth = () => {
		const { isNormalAuthEnabled } = this.state
		this.setState({ isNormalAuthEnabled: !isNormalAuthEnabled });
	}

	shouldShowForm = () => {
		const { isNormalAuthEnabled } = this.state;
		const {sso_ad, sso_adfs } = hp.settings

		const is_sso_adfs = sso_adfs > 0
		const is_sso_ad = sso_ad !== null;
	
		return (
		  (isNormalAuthEnabled && (is_sso_adfs || is_sso_ad)) ||
		  (!is_sso_adfs && !is_sso_ad)
		);
	  };

	render() {
		const { url_auth_gov, allow_portal_registering, allow_portal_recover, users_info_page_login } = hp.store
		const { _rp, sso_ad, sso_adfs } = hp.settings
		const { tfa, loading } = this.state
		const { user, plusinfo_class } = this

		// obrigatorio definir 2FA
		if (tfa == 2) {
			return (
				<div id="actionbox">
					<div className="form-vertical">
						<div className="section center">
							<em className="la la-user-shield x6" />
							<hr />
							<TwoFA pwdData={user} user={{}} loadQrcodeOnInit={true} onSubmitted={this.onNewCodeSubmitted} />
						</div>
					</div>
				</div>
			)
		}
		if (tfa == 1) {
			return (
				<div id="actionbox">
					<div className="form-vertical">
						<div className="section center">
							<em className="la la-user-shield x6" />
							<hr />
							<p>
								<button className="btn btn-default btn-circular" title={__("buttons_back")} onClick={this.onBack}>
									<em className="la la-undo"></em>
								</button>
								<span> </span>
								{__('security_2fa_code_info')}
							</p>
							<form onSubmit={this.onSubmitCode}>
								<p>
									<Input model={user} name='tfa_code' classNameEl="form-control input-sm center input-num" maxLength={6} autoFocus
										disabled={loading}
										placeholder={__("security_2fa_code")}
									/>
								</p>
								<div className="btn-group">
									<button type='submit' className="btn btn-success" disabled={loading}>
										<span>{__("buttons_validate")}</span>
										<em className="la la-sign-in"></em>
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			)
		}
		const sso_adfs_view = sso_adfs == 0 ? null :
			<form id="authsso" action={`/sessions/login.personal${hp.store.urlparams}`} method="post" className="input-group sign-container">
				<input type="hidden" name="sso" value="1" />
				<button type="submit" className="btn btn-success submit" disabled={loading} onClick={this.onSsoAdfsSubmit}>
					<span className='d-flex justify-content-center align-center'>{__("auth_sso_ad_submit")}</span>
					<em className='la la-arrow-right'></em>
				</button>
				<p />
			</form>

		const sso_ad_view = sso_ad == null ? null :
			<div className="input-group sign-container">
				<button type="button" className="btn btn-success submit" disabled={loading} onClick={this.onSsoAdSubmit}>
					<span className='d-flex justify-content-center align-center'>{__("auth_sso_ad_submit")}</span>
					<em className='la la-arrow-right'></em>
				</button>
				<p />
			</div>

		return (
			<>
				<div id="actionbox">
					<div className="form-vertical loginform">
						<div className="section">
							<em className="la la-user-lock x6" />
							<h4>{__('users_login')}</h4>
							<hr className='mb-0' />
						</div>
						
						{!this.shouldShowForm() && sso_adfs_view}

						{!this.shouldShowForm() && sso_ad_view}

						{ !this.shouldShowForm() && 
							<>
								<h4 className='or-separator'>OU</h4> 
								<div className="input-group sign-container pb-4">
									<button type="button" className="btn btn-custom submit" disabled={loading} onClick={this.onToggleNormAuth}>
										<span className='d-flex justify-content-center align-center'>{__("auth_normal_auth")}</span>
										<em className='la la-arrow-right'></em>
									</button>
								</div>
							</>
						}

						{this.shouldShowForm() && 
							<form  className='sign-container' onSubmit={this.onSubmit}>
								<div className="input-group my-0">
									<h4 className='title'>{__('auth_normal_auth')}</h4>
								</div>
								<div className="input-group">
									<label className="input-group-addon" htmlFor="username">
										<em className="la la-fw la-user"></em>
									</label>
									<Input model={user} name='username' required autoFocus
										disabled={loading}
										placeholder={__("attrs_username")}
									/>
								</div>

								<div className="input-group">
									<label className="input-group-addon" htmlFor="password">
										<em className="la la-fw la-lock"></em>
									</label>
									<Input model={user} name='password' type='password' required
										disabled={loading}
										placeholder={__("attrs_password")}
									/>
								</div>
								<div className="input-group my-0">
									<button type="submit" className="btn btn-default submit" disabled={loading}>
										<span>{__("buttons_enter")}</span>
										<em className="la la-sign-in"></em>
									</button>
								</div>
							</form>
						}
						{url_auth_gov
							?	<div className="input-group sign-container pb-4">
									<h4 className='title'>{__('auth_sso_gov')}</h4>
									<a href="#" onClick={this.onAuthGov}>
										<img src={`${hp.settings.tpldns}admin/img/login/autenticacao_azul.png`} alt="Autenticação.GOV" />
									</a>
								</div>
							: null
						}
						<div className="form-actions">
							{allow_portal_registering
								?	<div>
										<a href={`/users/register.html${_rp}`}>{__('users_register')}</a>
									</div>
								:	null
							}
							{allow_portal_recover & 1
								? <div>
									<a href={`/users/recover.html${_rp}`}>{__('users_recover_password')}</a>
								  </div>
								: null
							}
							{allow_portal_recover & 2
								? <div>
									<a href="/users/recover.html?type=u">{__('users_recover_username')}</a>
								  </div>
								: null
							}
						</div>
					</div>
					{url_auth_gov
						?	<form id="authgov" action={url_auth_gov} method="post">
								<input type="hidden" name="SAMLRequest" />
								<input type="hidden" name="RelayState" />
								<input type="submit" className="hidden" />
							</form>
						:	null
					}
				</div>
				<div id="plusinfo" className={plusinfo_class}>
					<div dangerouslySetInnerHTML={{__html: users_info_page_login}} />
				</div>
			</>
		)
	}
}

export default () => {
	const urlParams = hp.settings.urlParams = new URLSearchParams(window.location.search)

	hp.settings._r = urlParams.get('_r') ?? ''
	hp.settings._rp = hp.settings._r ? `?_r=${hp.settings._r}` : ''
	return (
		<SimpleApp>
			{hp.store.under_maintenance && urlParams.get('unlock') != 'ht' ? <Maintenance /> : <Login />}
		</SimpleApp>
	)
}
